import { Injectable } from '@angular/core';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { CommentModelDTO } from '../../dtos/comment.dto';

@Injectable({
  providedIn: 'root',
})
export class CommentsService {
  constructor(private apiService: APICoreService) {}

  getComments(refTable: string, refTableId: number) {
    return this.apiService.getRequest('comments', {
      ref_table: refTable,
      ref_table_id: refTableId,
    });
  }

  saveComment(newComment: CommentModelDTO) {
    return this.apiService.postRequest('comments', newComment);
  }

  deleteComment(comment: CommentModelDTO) {
    return this.apiService.deleteRequest(`comments/${comment.id}`);
  }
}
